import { IExternalLinkModel } from '@api/models';
import { addUserToExternalLink } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface AddUserToExternalLinkOptions {
    clientId: string;
    externalLink: IExternalLinkModel;
    folderId: string;
}

const useAddUserToExternalLinkForm = (options: AddUserToExternalLinkOptions) => {
    const { clientId, externalLink, folderId } = options;

    const addUserToExternalLinkMutation = useMutation((userIds: string[]) =>
        addUserToExternalLink(clientId, externalLink._id, userIds, folderId)
    );

    const submit = async (value: string[]) => {
        await addUserToExternalLinkMutation.mutateAsync(value);
    };

    return {
        isLoading: addUserToExternalLinkMutation.isLoading,
        submit,
    };
};

export default useAddUserToExternalLinkForm;
